import { Button } from "@devhop/ui";
import { HelpCircleIcon, PlusIcon } from "lucide-react";

type CategoriesToolbarProps = {
  canManage: boolean;
  onCreate: () => void;
  onStartTour?: () => void;
};

export function CategoriesToolbar({
  canManage,
  onCreate,
  onStartTour,
}: CategoriesToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div>
          <h2 className="flex items-center font-bold text-2xl tracking-tight">
            ຫມວດມູ່{" "}
            {onStartTour && (
              <Button
                variant="ghost"
                size="icon"
                onClick={onStartTour}
                className="ml-2 size-6"
                title="ເລີ່ມທົດລອງການນຳທາງ"
              >
                <HelpCircleIcon className="h-4 w-4" />
              </Button>
            )}
          </h2>
          <p className="text-muted-foreground">
            ຈັດການຫມວດມູ່ສິນຄ້າແບບລຳດັບຊັ້ນ
          </p>
        </div>
        <div
          className="flex items-center gap-2"
          data-tourid="catalog-categories-toolbar"
        >
          {canManage && (
            <Button onClick={onCreate}>
              <PlusIcon className="h-4 w-4" />
              ສ້າງຫມວດມູ່
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
